import React from "react";

const Welcome = ({ lenguaje }) => {
  /*   setTimeout(() => {
    //in order to make the 'writing black bar' disappear
    document
      .querySelector(".welcome")
      .style.setProperty("--writingBarDisplay", "none");
  }, 6000); */

  return (
    <div className="welcome" id="home">
      <h1>{lenguaje == "eng" ? "Hi, I'm Tomás" : "Hola, soy Tomás"}</h1>
      <p className="subtitle">
        {lenguaje == "eng"
          ? "Welcome to my portfolio"
          : "Bienvenido a mi portafolio"}
      </p>
      <p className="infoArrowKeys nonTouchableDevice">
        {lenguaje == "eng"
          ? "Use up and down keys or scroll to navigate"
          : "Use las flechas arriba y abajo para navegar"}
      </p>
      <p className="infoArrowKeys touchableDevice">
        {lenguaje == "eng"
          ? "Use left and right keys or swipe with your finger"
          : "Use las flechas izquierda y derecha o deslice con su dedo"}
      </p>
      <div className="icons">
        <svg
          enable-background="new 0 0 24 24"
          height="40"
          viewBox="0 0 24 24"
          width="40"
          xmlns="http://www.w3.org/2000/svg"
          className="upArrow"
        >
          <path d="m21.5 24h-19c-1.379 0-2.5-1.122-2.5-2.5v-19c0-1.378 1.121-2.5 2.5-2.5h19c1.379 0 2.5 1.122 2.5 2.5v19c0 1.378-1.121 2.5-2.5 2.5zm-19-23c-.827 0-1.5.673-1.5 1.5v19c0 .827.673 1.5 1.5 1.5h19c.827 0 1.5-.673 1.5-1.5v-19c0-.827-.673-1.5-1.5-1.5z" />
          <path d="m18.5 12.5h-15c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h15c.276 0 .5.224.5.5s-.224.5-.5.5z" />
          <path d="m15.5 15.5c-.128 0-.256-.049-.354-.146-.195-.195-.195-.512 0-.707l2.647-2.647-2.646-2.646c-.195-.195-.195-.512 0-.707s.512-.195.707 0l3 3c.195.195.195.512 0 .707l-3 3c-.098.097-.226.146-.354.146z" />
          <path d="m19.5 16c-.276 0-.5-.224-.5-.5v-7c0-.276.224-.5.5-.5s.5.224.5.5v7c0 .276-.224.5-.5.5z" />
        </svg>
        <svg
          enable-background="new 0 0 24 24"
          height="40"
          viewBox="0 0 24 24"
          width="40"
          xmlns="http://www.w3.org/2000/svg"
          className="downArrow"
        >
          <path d="m21.5 24h-19c-1.379 0-2.5-1.122-2.5-2.5v-19c0-1.378 1.121-2.5 2.5-2.5h19c1.379 0 2.5 1.122 2.5 2.5v19c0 1.378-1.121 2.5-2.5 2.5zm-19-23c-.827 0-1.5.673-1.5 1.5v19c0 .827.673 1.5 1.5 1.5h19c.827 0 1.5-.673 1.5-1.5v-19c0-.827-.673-1.5-1.5-1.5z" />
          <path d="m18.5 12.5h-15c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h15c.276 0 .5.224.5.5s-.224.5-.5.5z" />
          <path d="m15.5 15.5c-.128 0-.256-.049-.354-.146-.195-.195-.195-.512 0-.707l2.647-2.647-2.646-2.646c-.195-.195-.195-.512 0-.707s.512-.195.707 0l3 3c.195.195.195.512 0 .707l-3 3c-.098.097-.226.146-.354.146z" />
          <path d="m19.5 16c-.276 0-.5-.224-.5-.5v-7c0-.276.224-.5.5-.5s.5.224.5.5v7c0 .276-.224.5-.5.5z" />
        </svg>
      </div>
    </div>
  );
};

export default Welcome;
